import script from "./HeaderUniversiteitantwerpen.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderUniversiteitantwerpen.vue?vue&type=script&setup=true&lang=js"

import "./HeaderUniversiteitantwerpen.vue?vue&type=style&index=0&id=0abbed62&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0abbed62"]])

export default __exports__